import { useState } from 'react';
import { feedCards, feedFilters } from '@/mocks/home';

export default function FeedGrid() {
  const [active, setActive] = useState('全部');
  const list = active === '全部' ? feedCards : feedCards.filter((card) => card.category === active);

  return (
    <section id="feed" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新爆料 · 大图速览</h2>
            <p className="mt-1 text-sm text-foreground-600">封面驱动，热点进展一眼锁定</p>
          </div>
          <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
            {feedFilters.map((filter) => (
              <button
                key={filter}
                type="button"
                onClick={() => setActive(filter)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === filter
                    ? 'bg-foreground-950 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((card) => (
            <article
              key={card.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <a href="#feed" className="block h-48 w-full overflow-hidden md:h-52">
                <img
                  src={card.cover}
                  alt={card.title}
                  title={card.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </a>
              <div className="flex flex-1 flex-col p-4">
                <span className="self-start rounded bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700">
                  {card.category}
                </span>
                <h3 className="mt-3 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950">
                  {card.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{card.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {card.source}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}